import { r as registerInstance, h, a as Host } from './index-BntG-4Sv.js';
import { HtmlUtil } from '@ontotext/workbench-api';
import { T as TranslationService } from './translation.service-CyWR_ReZ.js';

const translateLabelCss = ":host{display:inline}";

const TranslateLabel = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.unsubscribeTranslationChanged = null;
        /**
         * The parameters passed to the translation.
         */
        this.translationParameters = [];
    }
    connectedCallback() {
        this.unsubscribeTranslationChanged = TranslationService.onTranslate(this.labelKey, this.translationParameters, (translatedLabel) => {
            this.translatedLabel = HtmlUtil.sanitize(translatedLabel);
        });
    }
    disconnectedCallback() {
        if (this.unsubscribeTranslationChanged) {
            this.unsubscribeTranslationChanged();
            this.unsubscribeTranslationChanged = null;
        }
    }
    render() {
        return h(Host, { key: '8a07d975cbf8baf4d96f8d6db8940f95d3bc7e8a', innerHTML: this.translatedLabel });
    }
};
TranslateLabel.style = translateLabelCss;

export { TranslateLabel as translate_label };
